import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appCapitalLetters]',
    standalone: true
})
export class CapitalLettersDirective {

  constructor(private elementRef: ElementRef) { }
  @HostListener('input', ['$event'])
  onChangeInput(): void {
    const initValue: string = this.elementRef.nativeElement.value.toUpperCase();
    this.elementRef.nativeElement.value = initValue;
  }

}
